<template>
  <v-container class="subheading">
    <v-layout text-xs-center wrap>
      <v-flex md7 text-xs-left>
       WORK IN PROGRESS
      </v-flex>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "NonTechBlog",
  data: function() {
    return {
      //
    };
  }
};
</script>
<style>

</style>
